import React from 'react';
import './Loader.css'; // Import the CSS file for styling

const Loader = ({ loader=true }) => {
    return (
        <div className={`${loader ? "loader-container" : "hidden"}`} >
            <div className="loader"></div>
        </div>
    );
}

export default Loader;
